import { render, staticRenderFns } from "./EventDetailsSection.vue?vue&type=template&id=d1764bcc&scoped=true"
import script from "./EventDetailsSection.vue?vue&type=script&lang=js"
export * from "./EventDetailsSection.vue?vue&type=script&lang=js"
import style0 from "./EventDetailsSection.vue?vue&type=style&index=0&id=d1764bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1764bcc",
  null
  
)

export default component.exports